import { render, staticRenderFns } from "./VirtualScrolling.vue?vue&type=template&id=49a1883f&scoped=true"
import script from "./VirtualScrolling.vue?vue&type=script&lang=ts"
export * from "./VirtualScrolling.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScrolling.vue?vue&type=style&index=0&id=49a1883f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a1883f",
  null
  
)

export default component.exports